import React from "react"
import { Form } from "react-bootstrap"
import { injectIntl } from "react-intl"
import RichTextWrapper from "../rich-text/RichTextWrapper"
import { LabelRichTextFormGroupProps } from "../types/labelRichTextFormGroup"

const LabelRichTextFormGroup = ({ formLabel, richTextProps }: LabelRichTextFormGroupProps) => {
    return <Form.Group>
        <Form.Label htmlFor="labelRichTextGroup" className="custom-form-label">
            {formLabel}
        </Form.Label>
        <RichTextWrapper {...richTextProps} />
    </Form.Group>
}

export default injectIntl(LabelRichTextFormGroup)


// WEBPACK FOOTER //
// ./src/common/form/LabelRichTextFormGroup.tsx